var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-personnel-edit"}},[_c('versement-banq-list-tab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }